import contactEfforts from "apis/contactEfforts";
import { HTTP_GET, HTTP_POST, HTTP_PUT, HTTP_DELETE, WebApiRequest } from "tools/webservice";

export const addCallLog = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: contactEfforts.addCallLog(payload.controlIdNumber),
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const updateCallLog = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: contactEfforts.updateCallLog(payload.contactEffortsId, payload.controlIdNumber),
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const deleteCallLog = (contactEffortsId, controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: contactEfforts.deleteCallLog(contactEffortsId, controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef,
});
export const getCallLog = (contactEffortsId, controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: contactEfforts.getCallLog(contactEffortsId, controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef,
});
export const updateCallDueDate = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: contactEfforts.updateCallDueDate(payload.ControlIdNumber),
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const getCallLogSettings = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: contactEfforts.getCallLogSettings(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef,
});
export const getCallLogContacts = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: contactEfforts.getCallLogContacts(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef,
});